var _circle, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReport2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 27,
    r: 27,
    fill: "#E7ECFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.2167 12H20.7833L12 20.7833V33.2167L20.7833 42H33.2167L42 33.2167V20.7833L33.2167 12ZM38.6667 31.8333L31.8333 38.6667H22.1667L15.3333 31.8333V22.1667L22.1667 15.3333H31.8333L38.6667 22.1667V31.8333Z",
    fill: "#A3AED0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0002 35.3333C27.9206 35.3333 28.6668 34.5871 28.6668 33.6667C28.6668 32.7462 27.9206 32 27.0002 32C26.0797 32 25.3335 32.7462 25.3335 33.6667C25.3335 34.5871 26.0797 35.3333 27.0002 35.3333Z",
    fill: "#A3AED0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3335 18.6667H28.6668V30.3334H25.3335V18.6667Z",
    fill: "#A3AED0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReport2);
export default __webpack_public_path__ + "static/media/report2.aac899890c7f26c95966a0554f33bbe3.svg";
export { ForwardRef as ReactComponent };